var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Breadcrumbs',{attrs:{"area":"Configurações","data":_vm.location}}),_c('div',{staticClass:"content"},[_c('Panel',{attrs:{"data":_vm.location}}),_c('Activeplan')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }